export function getScrollTop() {
    return window.pageYOffset;
}
